/**
 * 送料無料ライン表示の更新（snippets/free-shipping-message.liquid）
 * カート更新（PUB_SUB_EVENTS.cartUpdate）のたびに /cart.js を取得し、
 * ページ内の [data-free-shipping] をすべて最新の合計金額で書き換える。
 */
(() => {
  const SELECTOR = '[data-free-shipping]';

  const escapeHtml = (str) =>
    String(str || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  const formatMoney = (cents, format) => {
    const fmt = format || '{{amount_no_decimals}}円';
    const withDelimiters = (num, precision, thousands = ',', decimal = '.') => {
      const parts = (num / 100).toFixed(precision).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (parts[1] ? decimal + parts[1] : '');
    };

    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount':
          return withDelimiters(cents, 2);
        case 'amount_with_comma_separator':
          return withDelimiters(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return withDelimiters(cents, 0, '.', ',');
        default:
          return withDelimiters(cents, 0);
      }
    });
  };

  const render = (el, cart) => {
    const threshold = parseInt(el.dataset.threshold, 10) || 0;
    if (threshold <= 0) return;

    const total = cart.total_price;
    const remaining = threshold - total;
    const format = el.dataset.moneyFormat;
    const amountHtml = (cents) => `<span class="free-shipping__amount">${formatMoney(cents, format)}</span>`;

    let state;
    let text;
    if (cart.item_count === 0) {
      state = 'default';
      text = el.dataset.textDefault;
    } else if (remaining > 0) {
      state = 'remaining';
      text = el.dataset.textRemaining;
    } else {
      state = 'achieved';
      text = el.dataset.textAchieved;
    }

    el.dataset.state = state;

    const textEl = el.querySelector('[data-free-shipping-text]');
    if (textEl) {
      textEl.innerHTML = escapeHtml(text)
        .split('[threshold]').join(amountHtml(threshold))
        .split('[remaining]').join(amountHtml(remaining));
    }

    const progressEl = el.querySelector('[data-free-shipping-progress]');
    if (progressEl) {
      progressEl.style.width = `${Math.min(100, Math.floor((total / threshold) * 100))}%`;
    }
  };

  const refresh = () => {
    const elements = document.querySelectorAll(SELECTOR);
    if (!elements.length) return;

    const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    fetch(`${cartUrl}.js`, { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then((cart) => {
        document.querySelectorAll(SELECTOR).forEach((el) => render(el, cart));
      })
      .catch((e) => console.error(e));
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
  }

  // 戻るボタン（bfcache）で表示された場合も最新化
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) refresh();
  });

  // 外部アプリ等から手動更新したい場合：document.dispatchEvent(new Event('free-shipping:refresh'))
  document.addEventListener('free-shipping:refresh', refresh);
})();
